const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconRProgressPending(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconR-progress-pending",
    x: 0,
    y: 0,
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,1c7.727,0 14,6.273 14,14c-0,7.727 -6.273,14 -14,14c-7.727,-0 -14,-6.273 -14,-14c-0,-7.727 6.273,-14 14,-14Zm-0,2.181c6.523,-0 11.819,5.296 11.819,11.819c0,6.523 -5.296,11.819 -11.819,11.819c-6.523,0 -11.819,-5.296 -11.819,-11.819c-0,-6.523 5.296,-11.819 11.819,-11.819Z",
    style: {
      fill: "#d6d6d6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.803,16.261c-0.195,0.195 -0.316,0.466 -0.316,0.764c-0,0.299 0.121,0.569 0.317,0.765l4.445,4.446c0.196,0.195 0.467,0.316 0.765,0.316c0.299,0 0.569,-0.121 0.765,-0.316l4.446,-4.446c0.195,-0.196 0.317,-0.466 0.317,-0.765c-0,-0.597 -0.485,-1.082 -1.082,-1.082c-0.299,0 -0.569,0.121 -0.765,0.317c-0,0 -2.599,2.599 -2.599,2.599c0,-0 0,-10.374 0,-10.374c0,-0.597 -0.484,-1.082 -1.082,-1.082c-0.597,0 -1.082,0.485 -1.082,1.082l0,10.374l-2.598,-2.599c-0.196,-0.196 -0.467,-0.317 -0.765,-0.317c-0.299,0 -0.569,0.121 -0.765,0.317l-0.001,0.001Zm16.32,-7.727c0.263,-0.152 0.451,-0.407 0.519,-0.703c0.069,-0.296 0.011,-0.607 -0.158,-0.859c-2.423,-3.446 -6.203,-5.624 -10.41,-5.927c-0.26,-0.014 -0.577,0.103 -0.77,0.282c-0.199,0.184 -0.303,0.475 -0.304,0.783c-0,0.098 -0,-0.024 -0,0.072c0,0.505 0.394,1.011 0.898,1.04c3.521,0.261 6.738,2.091 8.767,4.975c0.32,0.473 0.971,0.642 1.456,0.339c0.007,-0.004 0,-0.001 0.002,-0.002Z",
    style: {
      fill: "#f80"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRProgressPending);
export default __webpack_public_path__ + "static/media/iconR-progress-pending.9deeb1e9e862857516d08dc81a8b7826.svg";
export { ForwardRef as ReactComponent };